import { PlatformConfiguration } from '../model';

export const configuration: PlatformConfiguration = {
  button: {
    background: 'image',
    type: 'primary',
  },
  input: {
    label: 'inline',
  },
  amountInput: {
    variant: 'outlined',
    border: 'standard',
  },
  errors: {
    position: 'top',
    type: 'container',
  },
  balance: {
    visible: true,
  },
};
